import type { BodyRouteParamsRequest } from '@pba/react-utils';
import { type ApiClientResponse, apiClient, routes } from 'common/services';
import type { PostContentObjectDetailDataObject } from 'models/service';

type EditPostRequestBody = {
  /* eslint-disable @typescript-eslint/naming-convention -- Start: Keys are defined by Backend API endpoint */
  attachments?: Array<{ id: string }>;
  html_content: string;
  program_topic_id: string;
  publish_at: string;
  text_content?: string;
  title: string;
  todo_due_date: string;
  /* eslint-enable @typescript-eslint/naming-convention -- End: Keys are defined by Backend API endpoint */
};

export const editPost = async ({
  body,
  routeParams: { id },
}: BodyRouteParamsRequest<EditPostRequestBody, { id: string }>) =>
  apiClient.put<PostContentObjectDetailDataObject, ApiClientResponse<PostContentObjectDetailDataObject>>(
    routes.posts.update(id),
    {
      post: body,
    },
  );
